/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import "./ServiceSet.css";
import { useNavigate } from "react-router-dom";
import Icon1 from "../../Image/serviceset/ServingTea.jpg";


import Icon2 from "../../Image/serviceset/iStockDeepCleaning.jpg";
import Icon3 from "../../Image/ServiceList/faceeeee.png";

import Icon4 from "../../Image/serviceset/iStockWarehouse.jpg";


import Icon5 from "../../Image/ServiceList/GuestHouseee.png";

import Icon6 from "../../Image/ServiceList/gardenAI.png";

import Icon7 from "../../Image/ServiceList/pestcontrolAI.png";
import Icon8 from "../../Image/ServiceList/BankingMen.png";
import Icon9 from "../../Image/ServiceList/staffhouse.png";
import Icon10 from "../../Image/serviceset/EventCleaning.jpg";
import Icon11 from "../../Image/serviceset/iStockHousekeeping.jpg";
import Icon12 from "../../Image/serviceset/HardServices.jpg"

const fmServices = [
  { icon: Icon11, title: "Comprehensive Housekeeping & Janitorial Services", category: "Cleaning", desc: "Professional cleaning for corporate, industrial & commercial spaces", link: "/housekeeping" },
 { icon: Icon4, title: "Industrial & Warehouse Deep Cleaning", category: "Industrial", desc: "Heavy-duty cleaning for plants", link: "/corporate-IndustrialWarehouseCleaning" },
 

  { icon: Icon1, title: "Pantry & Cafeteria  Support Services", category: "Pantry", desc: "Reliable beverage & pantry services", link: "/corporate-pantryservices" },
  { icon: Icon12, title: " Comprehensive Engineering & Technical Maintenance Service ", category: "Engineering", desc: "Building asset maintenance", link: "/corporate-EngineeringTechnical" },
  { icon: Icon2, title: "Deep Cleaning & Transformation Services", category: "Cleaning", desc: "Deep cleaning for offices & industries", link: "/corporate-deepcleaning" },
  { icon: Icon3, title: "Façade & External Cleaning", category: "Cleaning", desc: "Building exterior cleaning", link: "/corporate-FacadeExternalCleaning" },
 

  
  { icon: Icon5, title: " Guest House & Staff Accommodation", category: "Staffing", desc: "Guest house operations", link: "/corporate-guesthouse" },
  { icon: Icon6, title: "Landscape & Horticulture Services", category: "Landscape", desc: "Green area maintenance", link: "/corporate-landscaping" },
  { icon: Icon7, title: "Pest Control Services", category: "Pest Control", desc: "General and targeted pest control", link: "/corporate-pestcontrol" },
  { icon: Icon8, title: "Staffing Management", category: "Staffing", desc: "Skilled & unskilled manpower supply", link: "/corporate-manpowerstaffing" },
  { icon: Icon9, title: "Front Office & Helpdesk Management", category: "Front Office", desc: "Customer-facing executive support", link: "/corporate-frontoffice" },
  { icon: Icon10, title: "Event Cleaning", category: "Event", desc: "Event cleaning teams", link: "/corporate-eventcleaning" },
];

export default function FmServiceSet() {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchText, setSearchText] = useState("");

  const categories = ["All", "Cleaning", "Pantry", "Engineering", "Industrial", "Staffing", "Landscape", "Pest Control", "Front Office", "Event"];

  const filteredServices = fmServices.filter(service => {
    const matchCategory = selectedCategory === "All" || service.category === selectedCategory;
    const matchSearch =
      service.title.toLowerCase().includes(searchText.toLowerCase()) ||
      service.desc.toLowerCase().includes(searchText.toLowerCase());
    return matchCategory && matchSearch;
  });

  return (
    <section className="fmService-wrapper">

      <div className="fmService-header">
        <div className="fmService-pill"><span>What We Offer</span></div>
        <h2 className="fmService-title">Our Services</h2>
        <p className="fmService-subtitle">
          Comprehensive facility management solutions tailored to your needs
        </p>
      </div>

      <div className="fmService-filterBar">
        <select
          className="fmService-dropdown"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          {categories.map((cat, i) => (
            <option key={i}>{cat}</option>
          ))}
        </select>

        <input
          type="text"
          className="fmService-search"
          placeholder="Search services..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>

      <div className="fmService-grid">
        {filteredServices.map((service, idx) => (
          <div className="fmService-card" key={idx}>
            <div className="fmService-imageWrap">
              <img src={service.icon} alt={service.title} />
            </div>

            <h3 className="fmService-card-title">{service.title}</h3>
            <p className="fmService-card-desc">{service.desc}</p>

            <div
              className="fmService-learnMore"
              onClick={() => navigate(service.link)}
            >
              Learn More <span className="fmService-arrow">→</span>
            </div>
          </div>
        ))}
      </div>

    </section>
  );
}
